<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Question History</span>
    <a class="button waves-effect" (click)="onNoClick()">
      <i class="material-icons button__icon">cancel</i>
      <span class="button__text">Close</span>
    </a>
  </div>
  <div class="ttmodal__body" *ngIf="historyList.length > 0"
    style="display: flex; flex-direction: column; margin-top: 10px;">
    <span class="ttmodal__title">Viewing history for Question </span>
    <span class="ttmodal__title"><b>{{QuestionHistoryresult.QTitle}} </b></span>
    <table class="table table--full-width table--striped table--hover" style="min-width: max-content; height: 500px; overflow-y: auto; margin-top: 10px;">
      <tbody>
        <ng-container *ngFor="let fq of historyList">
          <tr style="border: groove;">
            <td>
              <a (click)="LoadSelectedCatData(fq.FormId,fq.SectionId, fq.QId, fq.UploadId)">
                <i class="material-icons button__icon"
                  style="font-size: 28px; vertical-align: middle; margin-right: 20px; cursor: pointer">pageview</i>
              </a>
            </td>
            <td>
              <div *ngIf="fq.SelectedQuestion" style="display: flex; flex-direction: column;color: blue;">
                <span><b>Completed Date: </b>{{fq.CompletedDate}}</span>
                <span><b>Form Name: </b>{{fq.FormName}}</span>
                <span><b>Answered By: </b>{{fq.InspectorName | aesDecrypt}}</span>
              </div>
              <div *ngIf="!fq.SelectedQuestion" style="display: flex; flex-direction: column;">
                <span><b>Completed Date: </b>{{fq.CompletedDate}}</span>
                <span><b>Form Name: </b>{{fq.FormName}}</span>
                <span><b>Answered By: </b>{{fq.InspectorName | aesDecrypt}}</span>
              </div>
            </td>
            <ng-container *ngFor="let obs of fq.ObPointsInfo">
              <td>
                <div style="display: flex; flex-direction: column;">
                  <span><b>Component: </b>{{obs.ComponentName}}</span>
                  <span><b>Obs:</b> {{obs.ObPointName}}</span>
                </div>
                <ng-container *ngFor="let reading of obs.ObsReading">
                  <div style="display: flex; flex-direction: row;">
                    <span><b>Reading #: </b>{{reading.ReadingNum}} </span>
                    <span><b> Measurement:</b> {{reading.Measurement}} </span>
                  </div>
                </ng-container>
              </td>
            </ng-container>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div *ngIf="historyList.length==0" class="ttmodal__body"
    style="display: flex; flex-direction: column;align-items: center; margin-top: 10%;">
    <span class="ttmodal__title" style="font-size: large;"> There is no Question History to View </span>
  </div>
</div>